import {
	AccountBalanceRounded,
	CompareArrowsRounded,
	DashboardRounded,
	GroupsRounded,
	Inventory2Rounded,
	LeaderboardRounded,
	StoreRounded,
	Timelapse,
	TrendingUpRounded,
} from "@mui/icons-material";
import HomeRounded from "@mui/icons-material/HomeRounded";
import CollectionsRoundedIcon from "@mui/icons-material/CollectionsRounded";

import { Route } from "react-router-dom";
import Reports from "./Reports";
import DashboardNavCollapsableWithCustomNav from "components/Layout/DashboardNavCollapsableWithCustomNav/DashboardNavCollapsableWithCustomNav";
import { arrType, datatypes, inputTypes } from "data/globalData";
import { rootProtectedPath } from "data/authData";
import moment from "moment";

export const getColumnValue = (row, obj) => {
	if (row?.data_type === datatypes.DATE.key) {
		return moment(obj?.[row.key]).format("DD-MM-YYYY") || "--";
	} else if (row.input_type == inputTypes.MULTIPLE_SELECT.key) {
		return obj?.[row.key]?.join(", ") || "--";
	} else {
		return obj?.[row.key] || "--";
	}
};

export const reportsDashboardSideNavList = {
	HOME: { name: "Home", key: "HOME", display: true, icon: <HomeRounded /> },
	aop_tracker: { name: "Revenue AOP VS Actual", key: "aop_tracker", display: true, icon: <HomeRounded /> },
	SALE: {
		name: "Sale",
		key: "SALE",
		icon: <TrendingUpRounded />,
		display: true,
		types: {
			summary: {
				name: "Summary",
				key: "summary",
				icon: <StoreRounded />,
				display: true,
			},
			shopify_live_sale: {
				name: "Shopify Live Sale",
				key: "shopify_live_sale",
				display: true,
				icon: <CollectionsRoundedIcon />,
			},
		},
	},
	INVENTORY: { name: "Inventory", key: "INVENTORY", display: true, icon: <Inventory2Rounded /> },
	EFFICENCY: {
		name: "Effiency",
		key: "EFFICENCY",
		display: true,
		icon: <Timelapse />,
		types: {
			EBO: {
				name: "EBO",
				key: "EBO",
				icon: <StoreRounded />,
				display: true,
				types: {
					SAME_STORE_GROWTH: {
						name: "SAME STORE GROWTH",
						key: "SAME_STORE_GROWTH",
						icon: <DashboardRounded />,
						display: true,
					},
					STAFF_COUNT: { name: "STAFF COUNT", key: "STAFF_COUNT", icon: <DashboardRounded />, display: true },
					INVENTORY_INDEX: { name: "INVENTORY INDEX", key: "INVENTORY_INDEX", icon: <DashboardRounded />, display: true },
					// 	RETURNS_BEHAVIOUR: {
					// 		name: "RETURNS BEHAVIOUR",
					// 		key: "RETURNS_BEHAVIOUR",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	SELL_THROUGH: { name: "SELL THROUGH ", key: "SELL_THROUGH", icon: <DashboardRounded />, display: true },
					// 	MRP_WISE_CONTRIBUTION: {
					// 		name: "MRP WISE CONT.",
					// 		key: "MRP_WISE_CONTRIBUTION",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	REPEAT_BEH_CAT_LEVEL: {
					// 		name: "REPEAT BEH ON CAT LEVEL",
					// 		key: "REPEAT_BEH_CAT_LEVEL",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	INTERNAL_MARKET_SHARE_PERCENT: {
					// 		name: "INTERNAL MARKET SHARE %",
					// 		key: "INTERNAL_MARKET_SHARE_PERCENT",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	CASH_CARD_REPORT: {
					// 		name: "CASH & CARD REPORT",
					// 		key: "CASH_CARD_REPORT",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	INVENTORY_VIEW: { name: "INVENTORY VIEW", key: "INVENTORY_VIEW", icon: <DashboardRounded />, display: true },
					// 	TGT_VS_ACHV_OF_SALES: {
					// 		name: "TGT VS ACHV OF SALES",
					// 		key: "TGT_VS_ACHV_OF_SALES",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	LOSS_OF_CUST_ABOLUTE_STR_WISE_L2L_STRUCTURE: {
					// 		name: "LOSS OF CUST ABSOLUTE STR WISE L2L STRUCTURE",
					// 		key: "LOSS_OF_CUST_ABOLUTE_STR_WISE_L2L_STRUCTURE",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	SO_PENDING_REPORT: {
					// 		name: "SO PENDING REPORT",
					// 		key: "SO_PENDING_REPORT",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	LEFT_REP_OF_STORES: {
					// 		name: "LEFT REP OF STORES",
					// 		key: "LEFT_REP_OF_STORES",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	FASHIONABILITY_TREND: {
					// 		name: "FASHIONABILITY TREND",
					// 		key: "FASHIONABILITY_TREND",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
					// 	ST_Comparison_LY_TY: {
					// 		name: "ST Comparison LY TY",
					// 		key: "ST_Comparison_LY_TY",
					// 		icon: <DashboardRounded />,
					// 		display: true,
					// 	},
				},
			},
			// MBO: { name: "MBO", key: "MBO", display: true, icon: <StoreRounded /> },
			// LFS: { name: "LFS", key: "LFS", display: true, icon: <StoreRounded /> },
			// D2C: { name: "D2C", key: "D2C", display: true, icon: <StoreRounded /> },
			// MARKETPLACE: { name: "MARKETPLACE", key: "MARKETPLACE", display: true, icon: <LanguageRounded /> },
			PICTORIAL_ST: { name: "Sell Through Pictorial ", key: "PICTORIAL_ST", display: true, icon: <CollectionsRoundedIcon /> },
			SO_TRACKER: { name: "SO Tracker ", key: "SO_TRACKER", display: true, icon: <CollectionsRoundedIcon /> },
		},
	},
	COMPARISON: { name: "Comparison", key: "COMPARISON", display: true, icon: <CompareArrowsRounded /> },
	MARKETING: { name: "Marketing", key: "MARKETING", display: true, icon: <LeaderboardRounded /> },
	CUSTOMER: { name: "Customer", key: "CUSTOMER", display: true, icon: <GroupsRounded /> },
	FINANCE: { name: "Finance", key: "FINANCE", display: true, icon: <AccountBalanceRounded /> },
};

// Recursive function to build routes
export const generateReportsRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types)
		return (
			<Route key={service.key} path={service.key}>
				{service.types &&
					Object.keys(service.types).map((childKey) =>
						generateReportsRoutesFromServiceTree(service.types[childKey], rootPath)
					)}
			</Route>
		);
	else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardNavCollapsableWithCustomNav
						drawerList={reportsDashboardSideNavList}
						searchParamName="tab"
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						baseUrl={rootProtectedPath}
					/>
				}>
				<Route index element={<Reports />} />
			</Route>
		);
};

export const groupByoptions = {
	hour: {
		name: "Hour",
		key: "hour",
	},
	day: {
		name: "Day",
		key: "day",
	},
};
export const moreOptions = {
	export: {
		name: "Export",
		key: "export",
	},
};
export const filterColArry = [
	// {
	// 	name: "Group BY",
	// 	key: "group_by",
	// 	input_type: inputTypes.SELECT.key,
	// 	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	// 	data: {},
	// 	data_type: datatypes.STRING.key,
	// 	sort_no: 1,
	// 	group: "",
	// 	placeholder: "",
	// 	default_value: "",
	// 	select_options: {
	// 		type: arrType,
	// 		list: [
	// 			{ name: "Hour", key: "hour" },
	// 			{ name: "Day", key: "day" },
	// 		],
	// 	},
	// },
	{
		name: "Product Vendor",
		key: "product_vendor",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Product Type",
		key: "product_type",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
	{
		name: "Sales Channel",
		key: "sales_channel",
		input_type: inputTypes.MULTIPLE_SELECT.key,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
		group: "",
		placeholder: "",
		default_value: "",
		select_options: {
			type: arrType,
			list: [
				// // { name: allOption, key: allOption },
				// { name: "RARE RABBIT", key: "RARE RABBIT" },
				// { name: "RAREISM", key: "RAREISM" },
				// { name: "RAREONES", key: "RAREONES" },
			],
		},
	},
];
